import IngredientsIconSvg from './ingredients-icon.svg';
import SaucepanIconSvg from './saucepan-icon.svg';
import HeartIconSvg from './heart-icon.svg';
import DeliveredIconSvg from './delivered-icon.svg';

export { IngredientsIconSvg, SaucepanIconSvg, HeartIconSvg, DeliveredIconSvg };
